import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    event: String,
    payload: { type: Object, default: {} },
    delayMs: { type: Number, default: 0 },
  }

  connect() {
    if (window.parent === window) return

    if (this.delayMsValue > 0) {
      this.timer = setTimeout(() => this.post(), this.delayMsValue)
    } else {
      this.post()
    }
  }

  disconnect() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  }

  post() {
    window.parent.postMessage(
      { type: this.eventValue, ...this.payloadValue },
      '*',
    )
  }
}
